module.exports = __webpack_public_path__ + "static/assets/5965deb09137398aa3c57d76d2f19587.png";